


/**
 * Fetches driving distance in miles between two addresses using backend proxy to Google Maps Distance Matrix API.
 * @param origin Full address string (e.g., '7230 Jemmah Lane, Jacksonville, Florida')
 * @param destination Full address string (e.g., '123 Main St, Orlando, Florida')
 * @returns Distance in miles (number)
 */
export async function fetchDistanceFromApi(origin: string, destination: string): Promise<number> {
  const url = `/api/distance?origin=${origin}&destination=${destination}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (
      data.rows &&
      data.rows[0] &&
      data.rows[0].elements &&
      data.rows[0].elements[0] &&
      data.rows[0].elements[0].distance
    ) {
      // distance.value is in meters
      const miles = data.rows[0].elements[0].distance.value / 1609.34;
      return miles;
    }
    throw new Error('Could not calculate distance');
  } catch (err) {
    console.error('[Distance API] Error:', err);
    throw err;
  }
}
